<template>
    
    <div class="helpCenter">
          <Navbar :backNative='true' title="帮助中心" />

          <div class="questions">
              <div class="question_card" v-for="(item,index) in list" :key="index">
                 <div class="card_left" @click="toShowMenu(index)">
                     <div class="content">
                      <img class="helpIcon" :src="item.image" alt="">
                      <div class="word">{{item.name}}</div>
                     </div>
                  
                       <img class="upOrDown" :src="item.isselect?require('../../assets/images/down.png') :require('../../assets/images/up.png') " alt="">
                 </div>
                 <div class="card_right">
                     <div class="question_title" @click="toDetail(it.id)"  v-for="(it,i) in item.questions" :key="i" >
                        {{it.title}}
                     </div>
                  
                  
                 </div>
              </div>
          </div>

    </div>
 
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http.js";
import { Toast } from 'vant';
export default {
  data() {
    return {
      list:[
         
      ]
    };
  },
  created() {
   
  },
  mounted() {
      
    //   Toast(1)
      this.$nextTick(()=>{
            if(this.refreshPage){
    //             http.getHelpType().then(res=>{
         
    //       res.map((item,index)=>{
    //           item.isselect=false
    //           item.tempQuestions=item.helpList.slice(0,2)
    //           item.questions=item.helpList.slice(0,2)
    //       })
    //        console.log(res)
    //        this.list=res
    //   })
    this.initPage()
            }
                 
      })
  },
  computed:{
         refreshPage(){
      return this.$store.state.refreshPage
    }
  },
  methods:{
      initPage(){
           
              http.getHelpType().then(res=>{
         
          res.map((item,index)=>{
              item.isselect=false
              item.tempQuestions=item.helpList.slice(0,2)
              item.questions=item.helpList.slice(0,2)
          })
           console.log(res)
           this.list=res
      })
      },
      toShowMenu(_index){//展开菜单
          this.list.map((item,index)=>{
              if(_index==index){
                  
                 item.isselect=!item.isselect
                 if(item.isselect){
                     item.questions=item.helpList
                 }else{
                     item.questions=item.tempQuestions
                 }
              }
              
          })
      },
      toDetail(id){
          this.$router.push({
              path:'/HelpDetail',
              query:{id}
          })
      }
  },
  components: {
    Navbar
  }
};
</script>
<style lang="less" scoped>

.helpCenter{
    .questions{
     .question_card{
         display: flex;
         .card_left{
             width: 100px;
             border: 1px solid #E9E9EB;
             border-left: none;
            //  height: 100px;
             padding-top: 24px;
             padding-bottom: 9px;
             box-sizing: border-box;
             display: flex;
             flex-direction: column;
             align-items: center;
             justify-content: space-between;
             .content{
                  display: flex;
             flex-direction: column;
             align-items: center;
             }
             .helpIcon{
                 width: 24px;
                 height: 24px;
             }
             .word{
                 font-size: 13px;
                 font-weight: 600;
                 margin-top: 4;
             }
             .upOrDown{
                 width: 8px;
                 transform: rotate(180deg);
                 transition: all 1s
                //  height: 16px;
             }
         }
         .card_right{
             flex:1;
             .question_title{
                 
                 height: 50px;
                 padding-left: 16px;
                 box-sizing: border-box;
                 border: 1px solid #E9E9EB;
                 border-right: none;
                 font-size: 15px;
                 color: #222030;
                 line-height: 50px;
               
             }
         }
     }
    }
}
</style>


